module.exports = __webpack_public_path__ + "img/business9.542e416f.png";